import { Button, Col, Form, message, Row } from "antd";
import LabelValue from "components/foundation/input/LabelValue";
import React from "react";
import { FaCopy } from "react-icons/fa6";
import { MRTRANS, MRTYPETRANS } from "utils/Constants/Constants";
import Format from "utils/format/Format";

interface TransDetailProps {
  info: any;
}

function getStatusText(Status: number) {
  const StatusObj = MRTRANS.find(
    (item: any) => item.value === Status || item.key === Status,
  );
  return StatusObj ? StatusObj.label : "N/A";
}

function getTypeText(type: number) {
  const typeObj = MRTYPETRANS.find(
    (item: any) => item.value === type || item.key === type,
  );
  return typeObj ? typeObj.label : "N/A";
}

const TransDetail: React.FC<TransDetailProps> = ({ info }) => {
  const form = Form.useFormInstance();

  const handleCopy = (value: string, type: "pin" | "serial") => {
    if (!value?.trim()) return;
    let textToCopy = value;
    if (type === "pin") {
      textToCopy = `*100*${value}#`;
    }

    navigator.clipboard.writeText(textToCopy).then(() => {
      message.success(
        type === "pin" ? "Đã sao chép mã pin!" : "Đã sao chép serial!",
      );
    });
  };

  return (
    <div>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="p-[30px] bg-white rounded-3xl shadow-md">
            <div className="text-[20px] font-bold border-b-[3px] border-gray-300 pb-2 mb-4">
              Thông tin chi tiết
            </div>
            <LabelValue
              label="Của hàng"
              value={info?.store_name}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Tên đơn"
              value={info?.name}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Thời gian tạo đơn"
              value={Format.formatFullDateTime(info?.created_at)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Mã đơn"
              value={info?.code}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Loại sản phẩm"
              value={getTypeText(info?.type)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Mã serial"
              value={info?.serial}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
              type="action"
              icon={FaCopy}
              onClick={() => handleCopy(info?.serial, "serial")}
            />
            <LabelValue
              label="Mã pin"
              value={info?.pin_code}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
              type="action"
              icon={FaCopy}
              onClick={() => handleCopy(info?.pin_code, "pin")}
            />
            <LabelValue
              label="Số điện thoại"
              value={info?.phone_number}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Mã giao dịch đối tác"
              value={info?.ref_code}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Trạng thái giao dịch"
              value={getStatusText(info?.status)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Thời gian thanh toán"
              value={Format.formatFullDateTime(info?.created_at)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Thời gian nạp"
              value={Format.formatFullDateTime(info?.updated_at)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={0}
            />
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="p-[30px] bg-white rounded-3xl shadow-md mb-4">
            <div className="text-[20px] font-bold border-b-[3px] border-gray-300 pb-2 mb-4">
              Chi tiết giá tiền
            </div>
            <LabelValue
              label="Số tiền thanh toán"
              value={Format.Price(info?.amount)}
              sm={9}
              bold="left"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <hr className="!border-gray-300 pb-2 mb-2" />
            <LabelValue
              label="Tổng tiền thanh toán"
              value={Format.Price(info?.amount)}
              sm={9}
              bold="true"
              color="#FF0606"
              textSize={14}
              textAlign="right"
              mb={0}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TransDetail;
